import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
    toggle(event) {
        event.preventDefault();
        const icon = event.currentTarget?.querySelector(".bi");
        const input = this.element.querySelector(".form-control");
        if (!icon || !input)
            return;
        if (icon.classList.contains("bi-eye-fill")) {
            icon.classList.remove("bi-eye-fill");
            icon.classList.add("bi-eye-slash-fill");
            input.type = "text";
        }
        else {
            icon.classList.add("bi-eye-fill");
            icon.classList.remove("bi-eye-slash-fill");
            input.type = "password";
        }
    }
}
